import { useState, useEffect } from "react";

function AddressPage(){

const [addresses,setAddresses] = useState([]);
const [newAddress,setNewAddress] = useState("");

useEffect(()=>{

const saved = JSON.parse(localStorage.getItem("addresses")) || [];
setAddresses(saved);

},[]);


const addAddress = () => {

if(!newAddress.trim()) return;

const updated = [...addresses,newAddress];

setAddresses(updated);

localStorage.setItem("addresses",JSON.stringify(updated));

setNewAddress("");

};

const deleteAddress = (index)=>{

const updated = addresses.filter((_,i)=>i!==index);

setAddresses(updated);

localStorage.setItem("addresses",JSON.stringify(updated));

};


return(

<div className="max-w-6xl mx-auto p-10">

<h1 className="text-2xl font-semibold mb-8">
Saved Addresses
</h1>


<div className="flex gap-3 mb-6">

<input
value={newAddress}
onChange={(e)=>setNewAddress(e.target.value)}
placeholder="Enter new address"
className="border p-2 rounded w-full"
/>

<button
onClick={addAddress}
className="bg-purple-600 text-white px-4 py-2 rounded"
>
Add
</button>

</div>


{addresses.length === 0 ? (

<p className="text-gray-500">
No saved addresses yet.
</p>

) : (

<div className="space-y-4">

{addresses.map((addr,index)=>(

<div
key={index}
className="border rounded-lg p-4 flex justify-between"
>

<p>{addr}</p>

<button
onClick={()=>deleteAddress(index)}
className="text-red-500"
>
Delete
</button>

</div>

))}

</div>

)}

</div>

);

}

export default AddressPage;